









import mixins from 'vue-typed-mixins';
import { Question } from '@/utils/SurveyUtils';
import { ReportNode, QuestionData } from '@/utils/ReportUtils';
export default mixins().extend({
  props: {
    value: {
      type: Object as () => ReportNode<Question, QuestionData>,
    },
  },

  computed: {
    answer(): any {
      return this.value.data?.participation?.answer || {};
    },

    readonly(): boolean {
      return !this.value.data.editable || false;
    },
  },

  methods: {
    async handleChange() {
      this.$emit('dirty');
      if (this.value.data.participation) {
        this.value.data.participation.completeness =
          this.answer.value?.length > 0 ? 1 : 0;
      }
    },
  },
});
